import '../augmentations';

import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typographyFontFamily = '"Nunito", "Roboto", "Helvetica", "Arial", sans-serif';

export const typographyFontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
} as const;

export type TypographyFontWeights = typeof typographyFontWeights;

export const typographyLineHeights = {
  tight: 1.2,
  snug: 1.3,
  normal: 1.4,
  relaxed: 1.5,
  loose: 1.75,
} as const;

export const typography: TypographyVariantsOptions = {
  fontFamily: typographyFontFamily,
  h1: {
    fontSize: '1.7rem',
    fontWeight: typographyFontWeights.bold,
    lineHeight: typographyLineHeights.tight,
  },
  h2: {
    fontSize: '1.6rem',
    fontWeight: typographyFontWeights.medium,
    lineHeight: typographyLineHeights.tight,
  },
  h3: {
    fontSize: '1.4rem',
    fontWeight: typographyFontWeights.medium,
    lineHeight: typographyLineHeights.snug,
  },
  h4: {
    fontSize: '1.2rem',
    fontWeight: typographyFontWeights.semiBold,
    lineHeight: typographyLineHeights.snug,
  },
  h5: {
    fontSize: '1.1rem',
    fontWeight: typographyFontWeights.semiBold,
    lineHeight: typographyLineHeights.normal,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: typographyFontWeights.semiBold,
    lineHeight: typographyLineHeights.normal,
  },
  subtitle1: {
    fontWeight: typographyFontWeights.semiBold,
    lineHeight: typographyLineHeights.normal,
  },
  subtitle2: {
    fontWeight: typographyFontWeights.semiBold,
    lineHeight: typographyLineHeights.normal,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: typographyFontWeights.regular,
    lineHeight: typographyLineHeights.relaxed,
  },
  body1Emphasis: {
    fontSize: '1rem',
    fontWeight: typographyFontWeights.bold,
    lineHeight: typographyLineHeights.relaxed,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: typographyFontWeights.regular,
    lineHeight: typographyLineHeights.normal,
  },
  body2Emphasis: {
    fontSize: '0.875rem',
    fontWeight: typographyFontWeights.bold,
    lineHeight: typographyLineHeights.normal,
  },
  button: {
    textTransform: 'none',
  },
  noItem: {
    fontSize: '0.875rem',
    fontStyle: 'italic',
    lineHeight: typographyLineHeights.normal,
    textAlign: 'center'
  },
};
